const avatarColors = [
  "#ffdd00",
  "#fbb034",
  "#ff4c4c",
  "#c1d82f",
  "#f48924",
  "#7ac143",
  "#30c39e",
  "#06BCAE",
  "#0695BC",
  "#037ef3",
  "#146eb4",
  "#8e43e7",
  "#ea1d5d",
  "#fc636b",
  "#ff6319",
  "#e01f3d",
  "#a0ac48",
  "#00d1b2",
  "#472f92",
  "#388ed1",
  "#a6192e",
  "#4a8594",
  "#7B9FAB",
  "#1393BD",
  "#5E13BD",
  "#E208A7",
];

const dummyContactsData = [
  {
    name: "Nika",
    surname: "Gunia",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: true,
    role: "Personal Fitness Trainer",
    messages: [
      {
        receiver: "Me",
        message: "Generated text message to help developers",
      },
      {
        sender: "Nika Gunia",
        message: "How is your training going?",
      },
      {
        receiver: "Me",
        message: "I am struggling to do Straight calf rises",
      },
      {
        sender: "Nika Gunia",
        message: "Why so?",
      },
      {
        receiver: "Me",
        message: "Whenever I step away from the machine,my back hurts",
      },
      {
        sender: "Nika Gunia",
        message:
          "Okay than,instead of doing heavy weights - few reps, do the opposite.",
      },
      {
        receiver: "Me",
        message: "Okay coach,thank you",
      },
      {
        sender: "Nika Gunia",
        message: "No worries,let me know when you ll need something else",
      },
      {
        receiver: "Me",
        message: "Okay coach,have a nice day!",
      },
    ],
  },
  {
    name: "Nika",
    surname: "Guladishvili",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Random Dude",
    messages: [
      {
        sender: "Nika Guladishvili",
        message: "How are you boy?",
      },
      {
        receiver: "Me",
        message: "Sore after todays workout,wby?",
      },
      {
        sender: "Nika Guladishvili",
        message: "Same here,do you want to train legs together tommorow?",
      },
      {
        receiver: "Me",
        message:
          "I've got injury on my right knee so doctor advised to not do any leg excersices",
      },
      {
        sender: "Nika Guladishvili",
        message: "Man thats awful,how long will it take to heal?",
      },
      {
        receiver: "Me",
        message: "Few months,might be a year",
      },
      {
        sender: "Nika Guladishvili",
        message: "That sucks man :/ I wish you easy recovery",
      },
      {
        receiver: "Me",
        message: "Thanks man,see you later!",
      },
      {
        sender: "Nika Guladishvili",
        message: "See you later broski",
      },
    ],
  },
  {
    name: "Tornike",
    surname: "Nizharadze",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Personal Fitness Trainer",
    messages: [
      {
        receiver: "Me",
        message: "Generated text message to help developers",
      },
      {
        sender: "Nika Gunia",
        message: "How is your training going?",
      },
      {
        receiver: "Me",
        message: "I am struggling to do Straight calf rises",
      },
      {
        sender: "Nika Gunia",
        message: "Why so?",
      },
      {
        receiver: "Me",
        message: "Whenever I step away from the machine,my back hurts",
      },
      {
        sender: "Nika Gunia",
        message:
          "Okay than,instead of doing heavy weights - few reps, do the opposite.",
      },
      {
        receiver: "Me",
        message: "Okay coach,thank you",
      },
      {
        sender: "Nika Gunia",
        message: "No worries,let me know when you ll need something else",
      },
      {
        receiver: "Me",
        message: "Okay coach,have a nice day!",
      },
    ],
  },
  {
    name: "Dachi",
    surname: "Avkopashvili",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Personal Nutriologist",
    messages: [
      {
        receiver: "Me",
        message: "Generated text message to help developers",
      },
      {
        sender: "Nika Gunia",
        message: "How is your training going?",
      },
      {
        receiver: "Me",
        message: "I am struggling to do Straight calf rises",
      },
      {
        sender: "Nika Gunia",
        message: "Why so?",
      },
      {
        receiver: "Me",
        message: "Whenever I step away from the machine,my back hurts",
      },
      {
        sender: "Nika Gunia",
        message:
          "Okay than,instead of doing heavy weights - few reps, do the opposite.",
      },
      {
        receiver: "Me",
        message: "Okay coach,thank you",
      },
      {
        sender: "Nika Gunia",
        message: "No worries,let me know when you ll need something else",
      },
      {
        receiver: "Me",
        message: "Okay coach,have a nice day!",
      },
    ],
  },
  {
    name: "Giorgi",
    surname: "Oboladze",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Jiu-Jitsu Gym Head",
    messages: [
      {
        sender: "Giorgi Oboladze",
        message: "Are you coming to the dojo today?",
      },
      {
        receiver: "Me",
        message: "I might come coach,I am not sure",
      },
      {
        sender: "Giorgi Oboladze",
        message: "You have competition coming up,dont miss to many trainings",
      },
      {
        receiver: "Me",
        message: "Got it coach",
      },
    ],
  },
  {
    name: "Niko",
    surname: "Muradashvili",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Friend",
    messages: [
      {
        receiver: "Me",
        message: "Generated text message to help developers",
      },
      {
        sender: "Nika Gunia",
        message: "How is your training going?",
      },
      {
        receiver: "Me",
        message: "I am struggling to do Straight calf rises",
      },
      {
        sender: "Nika Gunia",
        message: "Why so?",
      },
      {
        receiver: "Me",
        message: "Whenever I step away from the machine,my back hurts",
      },
      {
        sender: "Nika Gunia",
        message:
          "Okay than,instead of doing heavy weights - few reps, do the opposite.",
      },
      {
        receiver: "Me",
        message: "Okay coach,thank you",
      },
      {
        sender: "Nika Gunia",
        message: "No worries,let me know when you ll need something else",
      },
      {
        receiver: "Me",
        message: "Okay coach,have a nice day!",
      },
    ],
  },
  {
    name: "Vighac",
    surname: "Jigari",
    date: "14th July",
    message: "This is a placeholder message to test functionality....",
    isSelected: false,
    role: "Idk about this one",
    messages: [
      {
        receiver: "Me",
        message: "Generated text message to help developers",
      },
      {
        sender: "Nika Gunia",
        message: "How is your training going?",
      },
      {
        receiver: "Me",
        message: "I am struggling to do Straight calf rises",
      },
      {
        sender: "Nika Gunia",
        message: "Why so?",
      },
      {
        receiver: "Me",
        message: "Whenever I step away from the machine,my back hurts",
      },
      {
        sender: "Nika Gunia",
        message:
          "Okay than,instead of doing heavy weights - few reps, do the opposite.",
      },
      {
        receiver: "Me",
        message: "Okay coach,thank you",
      },
      {
        sender: "Nika Gunia",
        message: "No worries,let me know when you ll need something else",
      },
      {
        receiver: "Me",
        message: "Okay coach,have a nice day!",
      },
    ],
  },
];

const notificationsDummyData = [
  {
    txt: "Has messaged you",
    from: "Nika Guladishvili",
    date: "24h ago",
  },
  {
    txt: "Has sent you invitation request",
    from: "Nika Gunia",
    date: "2d ago",
  },
  {
    txt: "Has messaged you",
    from: "Sofia Nutriologist",
    date: "2d ago",
  },
  {
    txt: "Just posted a new video",
    from: "Nika Gunia",
    date: "24h ago",
  },
  {
    txt: "Has updated Premium plan programme",
    from: "C Bum",
    date: "1w ago",
  },
  {
    txt: "Your subscription is about to expire",
    from: "Joe Schmoe",
    date: "1m ago",
  },
  {
    txt: "Has suggested you new programme",
    from: "Nika Guladishvili",
    date: "1w ago",
  },
];

export { avatarColors, dummyContactsData, notificationsDummyData };
